import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EntityData } from 'common';
import { EntityService } from '../entity.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifb-entity-app-bar-title',
    templateUrl: './entity-app-bar-title.component.html',
    styleUrls: ['./entity-app-bar-title.component.scss'],
    standalone: false
})
export class EntityAppBarTitleComponent implements OnInit {

  title: string;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private entityService: EntityService) { }

  entityListNavigate() {
    this.router.navigateByUrl(this.entityService.prevEntityListUrl || '/company');
  }

  data;

  dataSet(data: AccountAppBarTitleComponentData) {
    this.data = data;
    this.title = data.entity.name ? `${data.entity.name}` : '';
  }

  ngOnInit() {
    this.route.data.pipe(untilDestroyed(this)).subscribe(this.dataSet.bind(this));
  }

}

export interface AccountAppBarTitleComponentData {
  entity: EntityData;
}
